<div class="step-card__container">
  <div class="card" [ngClass]="cardClasses" (click)="onStepClick()">
    @if (!special()) {
      <p class="step__number">{{ ('TGA.Step' | translate) + ' ' + stepNumber() }}</p>
    }
    <h2 class="step__name">{{ stepName() }}</h2>
  </div>
  <div class="connector">
    @if (!isLastAbsoluteStep()) {
      <div class="connector__line" [ngClass]="connectorLineClasses"></div>
    }
    <div class="connector__dot" [ngClass]="connectorDotClasses"></div>
  </div>
</div>
